/**
 * Slide — a single slide inside the Slider block. Static save: the frontend
 * markup is just an .embla__slide wrapper (sized by embla.min.css vars) around
 * whatever blocks the author placed inside.
 */
import { registerBlockType } from '@wordpress/blocks';
import {
  useBlockProps,
  useInnerBlocksProps,
  InnerBlocks,
} from '@wordpress/block-editor';
import metadata from './block.json';
import { SLIDE_BLANK_TEMPLATE } from '../_shared/slider-slide-defaults';

function Edit() {
  const blockProps = useBlockProps({ className: 'brandy-slide embla__slide' });
  // Only applies to a slide that mounts empty — one the author added by hand.
  // The slider's starter slides arrive pre-filled from its own template.
  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    template: SLIDE_BLANK_TEMPLATE,
    templateLock: false,
  });
  return <div {...innerBlocksProps} />;
}

function Save() {
  const blockProps = useBlockProps.save({ className: 'brandy-slide embla__slide' });
  return (
    <div {...blockProps}>
      <InnerBlocks.Content />
    </div>
  );
}

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: '#0061FE',
    src: (
      // Single frame with a content line — one slide.
      // Inline fill:none required: `foreground` adds .has-colors whose
      // `fill: currentcolor` overrides the SVG fill attribute.
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ fill: 'none' }}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="4.5" y="4.5" width="15" height="15" rx="1.5" />
        <path d="M8 14.5h8M8 11h5" />
      </svg>
    ),
  },
});
